export const MaterialUiHelperStyle = () => (
  <style>{`
    .MuiFormHelperText-contained.Mui-error {
      color: var(--flora--colors-error-standard);
      font-size: var(--flora--fontSizes-sm);
      margin: var(--flora--space-1) 0 0;
    }
  `}</style>
)
